export const handleLoading = (storeLoading, neededLoadingType) => {
  return storeLoading.type === neededLoadingType && storeLoading.state;
};